import { Select } from '@iwoca/orion';
import { UseFormRegister } from 'react-hook-form';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import residentialOptions from '../../../../helpers/residentialOptions';
import styles from '../PersonModal.module.css';
import { TPersonFormValues } from '../PersonModal.types';

const residentialOptionMessages = defineMessages({
    tenant: {
        id: '_.residential_options.tenant',
        defaultMessage: 'Tenant'
    },
    owner_with_mortgage: {
        id: '_.residential_options.owner_with_mortgage',
        defaultMessage: 'Owner occupier (with mortgage)'
    },
    owner_no_mortgage: {
        id: '_.residential_options.owner_no_mortgage',
        defaultMessage: 'Owner occupier (no mortgage)'
    },
    rent_free: {
        id: '_.residential_options.rent_free',
        defaultMessage: 'Living rent free (e.g. with parents)'
    }
});

export const ResidentialStatusQuestion = ({
    addressIndex,
    register
}: {
    addressIndex: number;
    register: UseFormRegister<TPersonFormValues>;
}) => {
    const intl = useIntl();

    return (
        <div data-testid="residential_status">
            <label>
                <FormattedMessage
                    id="_.person.residential_status"
                    defaultMessage="Residential status"
                />
            </label>
            <Select
                {...register(
                    `addresses.${addressIndex}.residential_status` as `addresses.${number}.residential_status`
                )}
                className={styles.ResidentialStatusSelect}
                data-testid="residential-select"
                defaultValue=""
            >
                <option value="" disabled>
                    {intl.formatMessage({
                        id: '_.person.residential_status_placeholder',
                        defaultMessage: 'Select residential status...'
                    })}
                </option>
                {residentialOptions.map(({ value }) => (
                    <option key={value} value={value}>
                        {intl.formatMessage(residentialOptionMessages[value])}
                    </option>
                ))}
            </Select>
        </div>
    );
};
